import {
  equals,
  filter,
  gte,
  isEmpty,
  length,
  match,
  split,
  trim
} from "ramda";
import moment from "moment";
import { currentLocale } from "../locale";
import * as Yup from "yup";

export const setOrdinal = value => {
  let s = ["th", "st", "nd", "rd"],
    v = value % 100;
  return value + (s[(v - 20) % 10] || s[v] || s[0]);
};

//now checks for at least 2 names that are at least 2 letters each
export const validateName = value => {
  let errorMessage;
  let singleName = value => split(" ", trim(value));
  let gtNameLength = value => gte(length(value), 2); //length(value)
  // let nameLength = value => length(value) < 2;

  if (isEmpty(value)) {
    errorMessage = currentLocale.nameRequired;
  } else if (length(value) < 5) {
    errorMessage = currentLocale.tooShort;
  } else if (length(value) > 50) {
    errorMessage = currentLocale.tooLong;
  } else if (isEmpty(match(/ /, trim(value)))) {
    errorMessage = currentLocale.bothNames;
    // } else if (!isEmpty(filter(nameLength, singleName(value)))) {
    //   errorMessage = currentLocale.tooShort;
  } else if (gte(1, length(filter(gtNameLength, singleName(value))))) {
    errorMessage = currentLocale.tooShort;
  }

  return errorMessage;
};

export const validateEmail = value => {
  let errorMessage;
  if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
    errorMessage = currentLocale.emailError;
  }
  return errorMessage;
};

export const validatePhoneNumbers = values => {
  let errorMessage;
  if (equals(values.phoneNumber, values.icePhoneNumber)) {
    errorMessage = currentLocale.icePhoneNumberError;
  }
  return errorMessage;
};

export const participantsAgeTest = value => {
  let errorMessage;
  const now = new Date();
  let today = age(moment(now).format("YYYY-MM-DD"));
  let format = age(moment(value).format("YYYY-MM-DD"));

  if (isEmpty(value)) {
    errorMessage = currentLocale.birthdayRequired;
  } else if (age(value) > 18) {
    errorMessage = currentLocale.participantsMaxAgeRequirement;
  } else if (format < today) {
    errorMessage = currentLocale.participantsMinAgeRequirement;
  }
  return errorMessage;
};

export const guardianAgeTest = value => {
  let errorMessage;
  //let format = moment(value).format("YYYY-MM-DD");

  if (age(value) < 18) {
    errorMessage = currentLocale.guardianMinAgeRequirement;
  } else if (age(value) > 125) {
    errorMessage = currentLocale.guardianMaxAgeRequirement;
  }
  return errorMessage;
};

///More Accurate\\\
export const age = value => {
  let birthday = +new Date(value);
  return ~~((Date.now() - birthday) / 31557600000);
};

export const FormikAppSchema = Yup.object().shape({
  name: Yup.string()
    .min(4, "Name is too short")
    .max(50, "Name is too long")
    .required("Name is required"),
  birthday: Yup.date()
    .typeError("Invalid Date")
    // .min(, "You must be 18 years old to participate")
    //.max(1900, "You better be under 100 to go parasailing")
    .required("Your birthday is required"),
  email: Yup.string()
    .email("Invalid Email Address")
    .required("Email Address is required for marketing information"),
  phoneNumber: Yup.number()
    // .min(5, "Phone number is too long")
    // .max(15, "Phone number is too short")
    .required("Phone number is required"),
  icePhoneNumber: Yup.number()
    // .min(5, "Phone Number is too short")
    // .max(15, "Phone Number is too long")
    .required("In case of emergency phone number is required")
  //optIn: Yup.bool().oneOf([true])
  // participants: Yup.array().of(
  //   Yup.object().shape({
  //     participantName: Yup.string()
  //       .min(4, "Too Short")
  //       .max(50, "Too Long")
  //       .required("First and Last Name are required"),
  //     participantDateOfBirth: Yup.date()
  //       .typeError("Invalid Date")
  //       // .min(18, "You must be 18 years old to participate")
  //       //.max(18, "Guardians can only sign for participants younger than 18")
  //       .required("Their birthday is required")
  //   })
  // )
});

// export const ParticipantSchema = Yup.object().shape({
//   name: Yup.string()
//     .min(2, "Name is too short")
//     .max(50, "Name is too long")
//     .required("Name is required"),
//   birthday: Yup.date()
//     .min(18, "You must be 18 years old to participate")
//     .max(100, "You better be under 100 to go parasailing")
//     .required("Your birthday is required")

// const ParticipantListSchema = Yup.object().shape({
//   participants: Yup.array()
//     .of(
//       Yup.object().shape({
//         participantName: Yup.string()
//           .min(4, "Too Short")
//           .max(50, "Too Long")
//           .required("First and Last Name are required"),
//         participantDateOfBirth: Yup.date()
//           .typeError("Invalid Date")
//           // .min(18, "You must be 18 years old to participate")
//           //.max(18, "Guardians can only sign for participants younger than 18")
//           .required("Their birthday is required")
//       })
//     )
//     .required("Complete all fields or remove them.")
// });

//.default(() => new Date())
// participantName: Yup()
//   .string()
//   .min(2, 'Name is too short')
//   .max(50, 'Name is too long)
//   .required('The Participant's name is required')
// });

///////////////MarketingValidationSchema\\\\\\\\\\\\\\\\
// const MarketingSchema = Yup.object().shape({
//   email: Yup.string()
//     .email("Invalid Email Address")
//     .required("Email Address is required for marketing information"),
//   phoneNumber: Yup.number()
//     // .min(5, "Phone number is too long")
//     // .max(15, "Phone number is too short")
//     .required("Phone number is required"),
//   icePhoneNumber: Yup.number()
//     // .min(5, "Phone Number is too short")
//     // .max(15, "Phone Number is too long")
//     .required("In case of emergency phone number is required")
// });
